import angular from "angular";

let mod = angular
    .module('capitalizeFirst', [])
    .directive('capitalizeFirst', ['uppercaseFilter', '$parse', function (uppercaseFilter, $parse) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {

                let capitalize = function(inputValue) {
                    if (inputValue === null || inputValue === undefined) {
                        inputValue = '';
                    }
                    let capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1);
                    if(capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                };

                let model = $parse(attrs.ngModel);

                modelCtrl.$parsers.push(capitalize);

                capitalize(model(scope));
            }
        }
    }]);

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/capitalize-first/capitalize-first.module.js